import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const manageAppsRoute: InvariantJiraRoute = {
	name: 'global-settings-addons-upm',
	path: '/plugins/servlet/upm',
};
